'use strict';

import {changeLangToCurrent, getCurrentLang} from '../language/langSwitcher';
import {
  createElements, findSelectionAndCrmData, getObjectFromLocalStorage, handleFavoriteLogic,
  numberWithCommas, removePropParam,
} from "../../functions";
import {Buildings, cardsData, isMobile, settingsData} from "../../settings";
import {moveElements} from "../navigation/right-nav-bar";
import {addApplyNow, removeOptionCardListeners, removeOptionsCardGallery} from './optionsCards';
import {changeCanvasSizeWhenCardIsOpened} from '../controls/orbitControls';
import {
  closeOptionsCardAnimation,
  closeUnitCardAnimation, openAndCloseMobileOptionsCard,
  openAndCloseMobileUnitCard
} from "./cardsAnimation";
import {CardTypes} from "../../common";
import {dataArrayOfFlat, facingDictionary} from "./cardsConfig";
import {toggleClassFavoritesInSearch} from "../search/search";
import {renderUpdateValuesOnDemand} from "../../app";
import {selectionBoxesSetStatusColor} from "../threejs/raycast";
import {analytics} from "../analytics/analytics";
import {similarFavoriteHandle} from "../search/similarSearch";
import {UnitCardClass} from "./unitCards/UnitCardClass";
import {setLordIcon} from '../../lordicon';
import {getPropType} from "./unitCards/unitCardFunctions";
import {closeNotifications} from '../analytics/statistic';

export const closeOptionsCard = () => {

  const body = document.body;
  const cardWrapper = document.querySelector(`.${CardTypes.Unit}-card__wrapper`);
  let cardBox = document.querySelectorAll(`.${CardTypes.Options}-card`);
  if (cardBox.length === 0) return;

  closeNotifications();
  removeOptionCardListeners();
  closeOptionsCardAnimation();
  setTimeout(() => renderUpdateValuesOnDemand(false), 1000);
  removePropParam();

  if (cardsData.cardMode.isAmenities) {
    settingsData.lastClickedFlat.userData.isClicked = false;
    selectionBoxesSetStatusColor(settingsData.lastClickedFlat, 'hoverOut');
    cardsData.cardMode.isAmenities = false;
  }

  if (isMobile) {
    removeOptionCardListeners();
    body.removeChild(document.querySelector(`.${CardTypes.Options}-card`));
    setTimeout(() => renderUpdateValuesOnDemand(false), 1000);

    const unitCard = UnitCardClass.findCard()?.html;
    if (unitCard) {
      cardWrapper?.childNodes.forEach(item => item.style.opacity = 1);

      if (!settingsData.isLandscape) {
        unitCard.addEventListener('swiped-up', openAndCloseMobileOptionsCard, false);
      } else if (settingsData.isLandscape && document.querySelector('html').getAttribute('dir') === 'rtl') {
        unitCard.addEventListener('swiped-right', openAndCloseMobileOptionsCard, {once: true});
      } else {
        unitCard.addEventListener('swiped-left', openAndCloseMobileOptionsCard, {once: true});
      }
    }

  }
}

export const createHeader = (...props) => {
  const [object, cardBoxWrapper, settings, card, resize, position = 'afterbegin'] = props;

  const cardBoxHeader = createElements('div', [`${card}-card__header`, 'card__header', `${settingsData.isConferenceHost && "conference"}`], cardBoxWrapper, position);

  const titleBox = createElements('div', [`${card}-card__title-box`, 'card__title-box'], cardBoxHeader);
  const subTitleBox = createElements('div', [`${card}-card__subtitle-box`, 'card__subtitle-box'], cardBoxHeader);
  addTitleBlock(object, titleBox, object.name, card);           // title

  // Apply now
  card === CardTypes.Options && isMobile && addApplyNow(!settingsData.isLandscape ? titleBox : document.querySelector(`.${card}-card__data`), resize);

  if (Buildings.getBuildingsInfoLength() > 1)
    addTowerName(subTitleBox, card, object, settings);                                            // tower name

  addFloor(object, subTitleBox, card);                                        // floor number

  // price
  if (!cardsData.cardMode.isAmenities && !isMobile) {
    addPriceBlock(object, titleBox, settings, card);
  } else if (card === CardTypes.Options && !cardsData.cardMode.isAmenities && isMobile) {
    addPriceBlock(object, settingsData.isLandscape ? titleBox : subTitleBox, settings, card);
  } else if (card === CardTypes.Unit && !cardsData.cardMode.isAmenities && isMobile) {
    addPriceBlock(object, titleBox, settings, card);
  } else {
    addPriceBlock(object, titleBox, settings, card);
  }
}

export const addTowerName = (parent, card, object, settings) => {
  // let towerName = buildings_info.find(option => option.isActive).towerName;
  const buildingData = settings.buildings.find(building => building.buildingEngineId === object.buildingEngineId);

  let towerName;

  if (Array.isArray(buildingData.buildingTitle) && buildingData.buildingTitle.length) {
    towerName = buildingData.buildingTitle.find(name => name.lang === getCurrentLang()).value;
  } else {
    towerName = object.buildingName;
  }


  // let towerName = object.buildingName;
  const regExp = /[a-z\u0590-\u05fe]/gi;
  const towerNameElement = createElements('div', [`${card}-card__tower-name`, `card__tower-name`], parent);

  const isStringName = regExp.test(towerName);
  if (!isStringName) {
    const towerNumber = createElements('span', [`${card}-card__tower-name_title`], towerNameElement);
    const towerTitle = createElements('span', [`${card}-card__tower-name_num`, 'language-string'], towerNameElement, 'beforeend', {
      data: 'data-dictionary',
      value: 'building'
    });

    towerNumber.innerHTML = towerName + ' ';
    towerTitle.innerHTML = changeLangToCurrent('building');
  } else {
    towerNameElement.innerHTML = towerName;
  }
}

export const addFloor = (object, parent, card) => {
  const towerNameElement = createElements('div', [`${card}-card__floor-number`, `card__floor-number`], parent);

  const floorName = createElements('span', ['language-string'], towerNameElement, 'beforeend', {
    data: 'data-dictionary',
    value: 'floor'
  });
  floorName.innerHTML = changeLangToCurrent('floor');

  const floorNumber = createElements('span', [`${card}-card__floor-number_num`], towerNameElement);
  floorNumber.innerHTML = object.floorNum;
}

export const addTitleBlock = (object, cardBox, title, card) => {
  const titleBlock = createElements('h3', [`${card}-card__title`, 'card__title'], cardBox);

  const flatName = createElements('span', [`${card}-card__title-flat-name`, 'language-string', 'card__title-flat-name'], titleBlock, 'beforeend', {
    data: 'data-dictionary',
    value: !cardsData.cardMode.isAmenities ? `${getPropType(object.propType)}` : object.propNum
  });
  flatName.innerHTML = !cardsData.cardMode.isAmenities ? `${changeLangToCurrent(getPropType(object.propType))}` : `${changeLangToCurrent(object.propNum)}`;

  const flatNumber = createElements('span', [`${card}-card__title-flat-number`, 'card__title-flat-number'], titleBlock);
  flatNumber.innerHTML = !cardsData.cardMode.isAmenities ? object.propNum : '';
}

export const addPriceBlock = (object, cardBox, settings, card) => {
  if (cardsData.cardMode.isAmenities) return;

  const isPrice = object.salePrice !== 0 && settings.crmProjectSettings.property.settings.displayPrice !== 'hide' || settingsData.isConferenceHost;
  const showPriceButton = settings.crmProjectSettings.property.settings.displayPrice === 'button';
  const priceBlock = createElements('div', [`${card}-card__price`, 'card__price'], cardBox);
  const currentCard = card === CardTypes.Unit ? document.querySelector(`.${card}-card.active`) : document.querySelector(`.${card}-card`);

  // Create price block when price available
  if (isPrice) {
    const currencyLocal = settings.crmProjectSettings.localization.currencyLabel;
    const priceValue = createElements('span', [`${card}-card__price-value`, 'card__price-value'], priceBlock);
    const priceCurrency = createElements('span', [`${card}-card__price-currency`, 'card__price-currency', 'language-string'], priceBlock, 'beforeend', {
      data: 'data-dictionary',
      value: currencyLocal
    });

    priceCurrency.innerHTML = isPrice ? changeLangToCurrent(currencyLocal) : '';

    if (showPriceButton && object.status === "Available" && isPrice) {
      addShowPriceBtn(card, priceBlock, priceValue, priceCurrency);
    }
  }

  // Create price block for sold flat
  if (object.status !== "Available") {
    currentCard.classList.add('unavailable');
    priceBlock.setAttribute('data-dictionary', object.status);
    priceBlock.classList.add('language-string');
    priceBlock.innerHTML = changeLangToCurrent(object.status);
    if (card === CardTypes.Unit) {
      currentCard.querySelector(`.${card}-card__wrapper`).classList.add('unavailable');
      currentCard.querySelector(`.${card}-card__plug`).classList.add('unavailable');
    }
  }
}

const addShowPriceBtn = (card, priceBlock, priceValue, priceCurrency) => {
  const showPriceButton = createElements('button', [`${card}-card__price-show-price-btn`, 'card__price-show-price-btn', 'language-string'], priceBlock, 'beforeend', {
    data: 'data-dictionary',
    value: 'show price'
  });
  showPriceButton.innerHTML = changeLangToCurrent('show price');
  priceValue.classList.add('hide');
  priceCurrency.classList.add('hide');

  showPriceButton.addEventListener('click', () => {
    showPriceButton.classList.toggle('hide');
    priceValue.classList.toggle('hide');
    priceCurrency.classList.toggle('hide');
  })
}

export const addInfopointsBlock = (...props) => {
  // const [object = settingsData.lastHoverObject, cardBox, card, settings] = props;
  const [object, cardBox, card, settings] = props;
  const infoPointsBlock = createElements('div', [`${card}-card__info-points`, 'card__info-points'], cardBox);

  cardsData.cardMode.isAmenities ? addCustomDataToUnitCard(object, card) : addFlatDataToUnitCard(object, infoPointsBlock, card, settings, cardBox);
}

export const addFlatDataToUnitCard = (object, infoPointsBlock, card, settings, cardBox) => {
  const regExp = /([A-Za-z])\w+/g;
  const measurement = config.localization.area ? config.localization.area : "m2";
  const showPrice = settings.crmProjectSettings.property.settings.displayPrice !== 'hide' || settingsData.isConferenceHost;
  const dictionary = facingDictionary();

  //price
  if (object.status === "Available" && object.salePrice !== 0 && showPrice) {
    const priceValue = cardBox.querySelector(`.${card}-card__price-value`);
    const price = numberWithCommas(Math.floor(object.salePrice));
    priceValue.innerHTML = price;
  }

  // info-points
  const cardsInfo = dataArrayOfFlat(object);

  if (card === 'compare') return;

  const infoPointsData = cardsInfo.filter(data => {
    if (card === CardTypes.Unit && config.features.apartments.aptCardFieldsCntUnit.indexOf(data.name) !== -1) {
      return data;
    } else if (card === CardTypes.Options && config.features.apartments.aptCardFieldsCntOptions.indexOf(data.name) !== -1) {
      return data;
    }
  });

  infoPointsData.forEach(data => {

    if (+data.data === 0) return;

    const cardContentBlock = createElements('div', [`${card}-card__info-points-block`, 'card__info-points-block'], infoPointsBlock);
    const cardContentWrapper = createElements('div', [`${card}-card__info-points-wrapper`, 'card__info-points-block-wrapper'], cardContentBlock);
    const cardModelName = createElements('div', [`${card}-card__info-points-block_data`, 'card__info-points-block_data'], cardContentWrapper);
    const cardModelNameText = createElements('span', [`${card}-card__info-points-block_data_text`, 'card__info-points-block_data_text', 'language-string'], cardModelName, 'beforeend', {
      data: 'data-dictionary',
      value: data.data,
    });
    const contentSubtext = createElements('div', [`${card}-card__info-points-block_subtitle`, 'card__info-points-block_subtitle'], cardContentWrapper);

    if (regExp.test(data.data))
      cardModelNameText.style.direction = "ltr";

    contentSubtext.innerHTML += `<span class="language-string" data-dictionary="${data.name}">${changeLangToCurrent(data.name)}</span>`;
    if (data.name === 'area') {
      const coma = `<span>,</span>`;
      contentSubtext.innerHTML += coma;
      const measurementTag = createElements('span', ['language-string', 'card__info-points-block_subtitle-measurement'], contentSubtext, 'beforeend', {
        'data': 'data-dictionary',
        'value': measurement
      });
      measurementTag.innerHTML += changeLangToCurrent(measurement);
      measurementTag.classList.add('meters');
    }

    cardModelNameText.innerHTML = changeLangToCurrent(data.data);
    cardModelName.classList.add(data.icon);

    if (data.name === 'accessible' || data.name === 'treatmentRoom') cardModelNameText.remove();

    if (data.name === 'exposure') {
      // const regExp = /,/g;
      // const dataArray = data.data.split(regExp);
      const dataArray = data.data;

      cardModelNameText.remove();

      dataArray.forEach(element => {
        for (let key in dictionary) {
          if (element === key) {
            const cardModelNameText = createElements('span', [`${card}-card__info-points-block_data_text`, 'card__info-points-block_data_text', 'language-string'], cardModelName, 'beforeend', {
              data: 'data-dictionary',
              value: dictionary[key].en + 'Short',
            });

            cardModelNameText.innerHTML = changeLangToCurrent(dictionary[key].en + 'Short');
          }
        }
      });
    }
  });
}

export const addCustomDataToUnitCard = (object, card) => {
  // const iconArray = object.userData.icons;
  // const infoArray = object.userData.infoPointsData;
  // const subtitleArray = object.userData.subtitle;
  const infoPointsBlock = document.querySelector(`.${card}-card__info-points`);

  // infoArray.forEach((item, index) => {
  //     const cardContentBlock = createElements('div', [`${card}-card__info-points-block`, 'card__info-points-block', subtitleArray[index] === "floor" ? 'floor-points' : null], infoPointsBlock);
  //     const cardContentWrapper = createElements('div', [`${card}-card__info-points-wrapper`, 'card__info-points-block-wrapper'], cardContentBlock);
  //
  //     const contentSubtitle = createElements('div', [`${card}-card__info-points-block_subtitle`, 'card__info-points-block_subtitle', 'language-string', card === CardTypes.Unit ? iconArray[index] : null], cardContentWrapper,'beforeend', {data: 'data-dictionary', value: subtitleArray[index]});
  //     contentSubtitle.innerHTML = changeLangToCurrent(subtitleArray[index]);
  //     const cardContent = createElements('div', [`${card}-card__info-points-block_data`, 'card__info-points-block_data', card === CardTypes.Options ? iconArray[index] : null], cardContentWrapper);
  //     cardContent.innerHTML = infoArray[index];
  // })
}

export const addFavoritesBlock = (object, cardBox, card) => {

  if (object.status !== "Available") return;

  const favoriteCheckboxBlock = createElements('div', [`${card}-card__favorite`, 'card__favorite', 'options-item'], cardBox,);
  const favoriteCheckbox = createElements('input', [`${card}-card__favorite-checkbox`, 'card__favorite-checkbox'], favoriteCheckboxBlock, 'beforeend', {
    data: 'type',
    value: 'checkbox'
  });
  favoriteCheckbox.setAttribute('id', `favorite-check-id__${card}`);
  // const favoriteLabel = createElements('label', [`${card}-card__favorite-label`, 'card__favorite-label', 'icon-unselected'], favoriteCheckboxBlock, 'beforeend', {
  //     data: 'for',
  //     value: `favorite-check-id__${card}`
  // });

  const favoriteLabel = createElements('label', [`${card}-card__favorite-label`, 'card__favorite-label', 'icon--lord-unselected'], favoriteCheckboxBlock, 'beforeend', {
    data: 'for',
    value: `favorite-check-id__${card}`
  });

  setLordIcon('favorite', favoriteLabel, {
    trigger: 'hover',
    stroke: 90,
    colors: 'primary:#ff0000,secondary:#ff0000'
  });

  const isInFavorite = getObjectFromLocalStorage(object.engineId);

  if (isInFavorite) {
    favoriteLabel.classList.remove('icon--lord-unselected');
    favoriteLabel.classList.add('icon-favorite_selected');
  }

  favoriteLabel.addEventListener('click', (e) => {
    e.stopPropagation();
    handleFavoriteLogic(e, 'cardClick')
  });
}


/**
 * Handlers
 */

// export const handleFavoriteLogic = (e, action) => {
//     if (e?.target?.classList.contains('similar-apt-card__favorite-label')) {
//         similarFavoriteHandle(e);
//         return;
//     }
//
//
//     const activeUnitCard = document.querySelector(`.${CardTypes.Unit}-card.active`);
//     const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);
//
//     let data;
//
//     if (e.target.closest('.search__result-item')) {
//         data = findSelectionAndCrmData(e.target.closest('.search__result-item').getAttribute('data-engineid'));
//     } else if (e.target.closest(`.${CardTypes.Unit}-card`)) {
//         data = findSelectionAndCrmData(e.target.closest(`.${CardTypes.Unit}-card`).getAttribute('data-engineid'));
//     } else if (e.target.closest(`.${CardTypes.Options}-card`)) {
//         data = findSelectionAndCrmData(e.target.closest(`.${CardTypes.Options}-card`).getAttribute('data-engineid'));
//     }
//
//     let storageData = getObjectFromLocalStorage(data.crmDataOfFlat);
//
//     switch (action) {
//         case ('searchClick'):
//             e.target.classList.toggle('icon-favorite_selected');
//             e.target.classList.toggle('icon-unselected');
//
//             if (!storageData) {
//                 addObjectToLocalStorage(data.crmDataOfFlat);
//             } else {
//                 removeObjectFromLocalStorage(data.crmDataOfFlat);
//             }
//
//             if (activeUnitCard) {
//                 const currentCard =  document.querySelector(`.${CardTypes.Unit}-card[data-engineid=${data.crmDataOfFlat.engineId}]`);
//
//                 if (!currentCard) return;
//
//                 const unitFavoriteLabel = currentCard.querySelector(`.${CardTypes.Unit}-card__favorite-label`);
//
//                 unitFavoriteLabel.classList.toggle('icon-favorite_selected');
//                 unitFavoriteLabel.classList.toggle('icon-unselected');
//
//             }
//             break
//         case ('cardClick'):
//             const currentCard = document.querySelector(`.${CardTypes.Unit}-card[data-engineid=${data.crmDataOfFlat.engineId}]`);
//             const label = currentCard.querySelector(`.${CardTypes.Unit}-card__favorite-label`);
//
//             label.classList.toggle('icon-favorite_selected');
//             label.classList.toggle('icon-unselected');
//
//             const searchItemLabel = document.querySelector(`.search__result-item[data-engineid=${data.crmDataOfFlat.engineId}] span[data-favorite=favorite]`);
//
//             if (searchItemLabel) {
//                 searchItemLabel.classList.toggle('icon-favorite_selected');
//                 searchItemLabel.classList.toggle('icon-unselected');
//             }
//
//             if (!storageData) {
//                 addObjectToLocalStorage(data.crmDataOfFlat);
//             } else {
//                 removeObjectFromLocalStorage(data.crmDataOfFlat);
//             }
//
//             if (optionsCard) {
//                 const currentOptionsCard = document.querySelector(`.${CardTypes.Options}-card[data-engineid=${data.crmDataOfFlat.engineId}]`);
//                 const optionsCardLabel = currentOptionsCard.querySelector(`.${CardTypes.Options}-card__favorite-label`);
//
//                 optionsCardLabel.classList.toggle('icon-favorite_selected');
//                 optionsCardLabel.classList.toggle('icon-unselected');
//             }
//     }
//
//     analytics('favorites', {storageData, crmDataOfFlat});
//
// }
